import React from "react";
import { getCurrencyFormat } from "../../../components/utils/currency";
import Tabbable from "../../../components/tabbable";
import "./planBox.scss";

const PlanBox = ({ plan, selected, selectedPlan, ...props }) => {
  const active = selectedPlan && plan.id === selectedPlan.id ? "active" : "";

  return (
    <Tabbable
      className={`plan-box ${active}`}
      onClick={() => props.onSelect(plan)}
      onMouseDown={e => e.preventDefault()}>
      <div className="plan-box-infos">
        <div className={`plan-box-radio ${active}`} />
        <span className={`plan-box-title ${active}`}>{plan.title}</span>
      </div>

      <div>
        <span className={`plan-box-price ${active}`}>{`${getCurrencyFormat(plan.price, "R$ ", "0").replace(
          ".",
          ","
        )}`}</span>
      </div>
    </Tabbable>
  );
};

export default PlanBox;
